(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g3d-frecce"]) return;
  try {
    
function initFrecce(root) {
  root.querySelectorAll('[data-frecce]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const select = section.querySelector('[data-frecce-select]');
    const button = section.querySelector('[data-frecce-buy]');
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      section.querySelector('[data-frecce-price]').textContent = option.dataset.price;
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.sold : button.dataset.add;
      section.querySelectorAll('[data-frecce-photo]').forEach(photo => {
        photo.hidden = photo.dataset.freccePhoto !== option.value;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
}
initFrecce(document);
document.addEventListener('shopify:section:load', event => initFrecce(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
